<template>
    <div class="work-order-list">
        <!-- 搜索区域 -->
        <div class="search-wrapper">
            <el-form :model="searchForm" class="search-form" size="small" label-width="auto">
                <!-- 第一行 -->
                <el-row :gutter="24">
                    <!-- <el-col :span="6">
                        <div class="form-item-wrapper">
                            <span class="label" style="width: 75px;">工单编号：</span>
                            <el-input v-model="searchForm.work_order_id" placeholder="请输入工单编号"></el-input>
                        </div>
                    </el-col> -->
                    <el-col :span="6">
                        <div class="form-item-wrapper">
                            <span class="label" style="width: 75px;">ICCID：</span>
                            <el-input v-model="searchForm.complaint_iccid" placeholder="请输入ICCID" clearable
                                @clear="handleClear('complaint_iccid')">
                            </el-input>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div class="form-item-wrapper">
                            <span class="label">登记人：</span>
                            <el-select v-model="searchForm.loginUser" filterable remote reserve-keyword clearable
                                placeholder="请输入登记人" :remote-method="remoteSearch" :loading="userLoading"
                                @clear="handleClear('loginUser')" @focus="handleUserSelectFocus">
                                <el-option v-for="item in userList" :key="item.userId" :label="item.realName"
                                    :value="item.userId">
                                    <span style="float: left; color: #8492a6; font-size: 13px">{{ item.realName
                                        }}</span>
                                </el-option>
                            </el-select>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div class="form-item-wrapper">
                            <span class="label">来源渠道：</span>
                            <el-select v-model="searchForm.source_no" placeholder="请选择来源渠道" clearable
                                @clear="handleClear('source_no')">
                                <el-option v-for="item in sourceChannelList" :key="item.itemValue"
                                    :label="item.itemLabel" :value="item.itemValue">
                                </el-option>
                            </el-select>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div class="form-item-wrapper">
                            <span class="label" style="width: 75px;">处理类型：</span>
                            <el-cascader v-model="searchForm.process_type_no" :options="handleTypeList"
                                :props="{ checkStrictly: true, emitPath: false }" placeholder="请选择处理类型" clearable
                                @clear="handleClear('process_type_no')">
                            </el-cascader>
                        </div>
                    </el-col>
                </el-row>

                <!-- 第二行 -->
                <el-row :gutter="24">
                    <el-col :span="6">
                        <div class="form-item-wrapper">
                            <span class="label" style="width: 75px;">投诉项目：</span>
                            <el-cascader v-model="searchForm.complaint_no" :options="complaintOptions"
                                :props="{ checkStrictly: true, emitPath: false }" placeholder="请选择投诉项目"
                                filterable clearable
                                @clear="handleClear('complaint_no')">
                            </el-cascader>
                        </div>
                    </el-col>

                    <el-col :span="6">
                        <div class="form-item-wrapper">
                            <span class="label">工单状态:</span>
                            <el-select v-model="searchForm.status_no" placeholder="请选择工单状态" clearable
                                @clear="handleClear('status_no')">
                                <el-option v-for="item in statusList" :key="item.itemValue" :label="item.itemLabel"
                                    :value="item.itemValue">
                                </el-option>
                            </el-select>
                        </div>
                    </el-col>

                    <el-col :span="6">
                        <div class="form-item-wrapper">
                            <span class="label">接单时间:</span>
                            <el-date-picker v-model="searchForm.timeRange" type="daterange" range-separator="至"
                                start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" clearable
                                @clear="handleClear('timeRange')">
                            </el-date-picker>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div class="form-item-wrapper" style="justify-content: flex-end;">
                            <el-button type="primary" @click="handleSearch">查询</el-button>
                            <el-button type="success" icon="el-icon-download" @click="handleExport">导出</el-button>
                            <el-button @click="resetSearch">重置</el-button>
                        </div>
                    </el-col>
                </el-row>

                <!-- 按钮行 -->

            </el-form>
        </div>

        <!-- 表格区域 -->
        <div class="table-section">
            <div class="table-header">
                <div class="header-left">
                    <h3>工单列表</h3>
                    <span class="total-count">共 {{ total }} 条记录</span>
                </div>

            </div>

            <!-- 替换表格为卡片列表 -->
            <div v-loading="loading" class="audit-list">
                <div v-if="tableData.length === 0" class="empty-data">
                    <el-empty description="暂无数据"></el-empty>
                </div>
                <template v-else>
                    <el-card v-for="item in tableData" :key="item.work_order_id || item.id" class="audit-item" shadow="hover">
                        <div class="info-container">
                            <div class="info-header">
                                <div class="header-left">
                                    <span class="order-time">
                                        <i class="el-icon-time"></i>
                                        创建时间：{{ formatRegDateTime(item.create_time) }}
                                    </span>
                                    <!-- <span class="creator">
                                        <i class="el-icon-user"></i>
                                        创建人：{{ item.creator || '-' }}
                                    </span> -->
                                    <el-tag size="small" :type="getStatusType(item.status_name)">
                                        处理结果：{{ item.status_name }}
                                    </el-tag>
                                </div>
                                <div class="header-right">
                                    <el-button type="text" size="small" @click="handleEdit(item)">
                                        <i class="el-icon-edit"></i> 编辑
                                    </el-button>
                                </div>
                            </div>

                            <div class="info-content">
                                <!-- ICCID和投诉项目一行 -->
                                <el-row :gutter="20">
                                    <el-col :span="6">
                                        <div class="info-item">
                                            <span class="value">
                                                <i class="el-icon-cpu"></i>
                                                ICCID: {{ item.complaint_iccid }}
                                            </span>
                                        </div>
                                    </el-col>
                                    <el-col :span="18">
                                        <div class="info-item complaint-item">
                                            <span class="value">
                                                <i class="el-icon-tickets"></i>
                                                投诉项目：{{ item.complaint_name || getComplaintFullPath(item.complaint_no) }}
                                            </span>
                                        </div>
                                    </el-col>
                                </el-row>
                                <!-- 其他信息 -->
                                <el-row :gutter="20">
                                    <el-col :span="6">
                                        <div class="info-item">
                                            <span class="value">
                                                <i class="el-icon-document-copy"></i>
                                                登记人:{{ item.real_name }}
                                            </span>
                                        </div>
                                    </el-col>
                                    <el-col :span="6">
                                        <div class="info-item">
                                            <span class="value">
                                                <i class="el-icon-document"></i>
                                                处理类型：{{ item.process_type_name }}
                                            </span>
                                        </div>
                                    </el-col>
                                    <el-col :span="6">
                                        <div class="info-item">
                                            <span class="value">
                                                <i class="el-icon-time"></i>
                                                工单时长：{{ calculateFlowTime(item.create_time) }}小时
                                            </span>
                                        </div>
                                    </el-col>
                                    <el-col :span="6">
                                        <div class="info-item">
                                            <span class="value">
                                                <i class="el-icon-position"></i>
                                                来源渠道：{{ item.source_name }}
                                            </span>
                                        </div>
                                    </el-col>
                                    <el-col :span="6">
                                        <div class="info-item">
                                            <span class="value">
                                                <i class="el-icon-office-building"></i>
                                                团队类型：{{ item.team_type_name }}
                                            </span>
                                        </div>
                                    </el-col>
                                    <el-col :span="6">
                                        <div class="info-item">
                                            <span class="value">
                                                <i class="el-icon-s-custom"></i>
                                                代理商：{{ item.representative_name }}
                                            </span>
                                        </div>
                                    </el-col>
                                    <el-col :span="6">
                                        <div class="info-item">
                                            <span class="value">
                                                <i class="el-icon-money"></i>
                                                收款金额：{{ item.payment_amount }}元
                                            </span>
                                        </div>
                                    </el-col>
                                    <el-col :span="6">
                                        <div class="info-item">
                                            <span class="value">
                                                <i class="el-icon-wallet"></i>
                                                客户付款：{{ item.customer_pay_amount }}元
                                            </span>
                                        </div>
                                    </el-col>
                                </el-row>
                                <!-- 问题描述 -->
                                <el-row>
                                    <el-col :span="24">
                                        <div class="info-item desc-item">
                                            <span class="value">
                                                <i class="el-icon-warning-outline"></i>
                                                问题描述：{{ item.problem_desc }}
                                            </span>
                                        </div>
                                    </el-col>
                                </el-row>
                            </div>
                        </div>
                    </el-card>
                </template>
            </div>

            <!-- 分页 -->
            <div class="pagination-container" v-if="total > 0">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page.sync="searchForm.page" :page-sizes="[5, 10, 20, 30, 40]"
                    :page-size="searchForm.pagesize" layout="total, prev, pager, next, jumper" :total="total"
                    :pager-count="7">
                </el-pagination>
            </div>
        </div>

        <!-- 详情对话框 -->
        <el-dialog title="工单详情" :visible.sync="dialogVisible" width="70%" custom-class="tech-dialog"
            :close-on-click-modal="false">
            <div class="order-detail">
                <div class="order-card">
                    <!-- 添加工单编号显示 -->
                    <div class="order-number">
                        <span class="number">{{ currentOrder?.orderNo }}</span>
                        <!-- <el-tag 
                            :type="getStatusType(currentOrder?.status)" 
                            effect="dark" 
                            size="medium">
                            {{ currentOrder?.status }}
                        </el-tag> -->
                    </div>

                    <!-- 各个部分的内容 -->
                    <div class="detail-grid">
                        <div class="section">
                            <div class="section-title">
                                <i class="el-icon-message"></i>
                                投诉来源
                                <div class="title-line"></div>
                            </div>

                            <div class="section-content">
                                <div class="info-item">
                                    <label>来源渠道：</label>
                                    <span>{{ sourceChannel }}</span>
                                </div>
                            </div>
                            <div class="section-title">
                                <i class="el-icon-warning"></i>
                                投诉级别
                                <div class="title-line"></div>
                            </div>
                            <div class="section-content">
                                <div class="info-item">
                                    <label>紧急程度：</label>
                                    <span>{{ urgencyLevel }}</span>
                                </div>
                            </div>
                            <div class="section-title">
                                <i class="el-icon-time"></i>
                                投诉时间
                                <div class="title-line"></div>
                            </div>
                            <div class="section-content">
                                <div class="info-item">
                                    <label>问题发生时间：</label>
                                    <span>{{ issueTime }}</span>
                                </div>
                            </div>
                        </div>

                        <div class="section">
                            <div class="section-title">
                                <i class="el-icon-document"></i>
                                投诉项目
                                <div class="title-line"></div>
                            </div>
                            <div class="section-content">
                                <div class="info-item">
                                    <label>投诉项目：</label>
                                    <span>{{ complaintItem }}</span>
                                </div>
                                <div class="info-item" v-if="iccid">
                                    <label>ICCID:</label>
                                    <span>{{ iccid }}</span>
                                </div>
                                <div class="info-item" v-if="cardNumber">
                                    <label>开卡号码：</label>
                                    <span>{{ cardNumber }}</span>
                                </div>
                            </div>
                            <div class="section-title">
                                <i class="el-icon-user"></i>
                                投诉用户
                                <div class="title-line"></div>
                            </div>
                            <div class="section-content">
                                <div class="info-item">
                                    <label>电话号码：</label>
                                    <span>{{ phoneNumber }}</span>
                                </div>
                                <div class="info-item">
                                    <label>ICCID：</label>
                                    <span>{{ userIccid }}</span>
                                </div>
                                <div class="info-item">
                                    <label>通道编码：</label>
                                    <span>{{ channelCode }}</span>
                                </div>
                            </div>
                        </div>

                        <div class="section">
                            <div class="section-title">
                                <i class="el-icon-s-custom"></i>
                                用户类型
                                <div class="title-line"></div>
                            </div>
                            <div class="section-content">
                                <div class="info-item">
                                    <label>用户类型：</label>
                                    <span class="text-left">{{ currentOrder?.teamType || '-' }}</span>
                                </div>
                            </div>
                            <div class="section-title">
                                <i class="el-icon-office-building"></i>
                                代理商信息
                                <div class="title-line"></div>
                            </div>
                            <div class="section-content">
                                <div class="info-item">
                                    <label>代理商名称：</label>
                                    <span class="text-left">{{ agentName }}</span>
                                </div>
                            </div>
                            <div class="section-title">
                                <i class="el-icon-document"></i>
                                问题描述
                                <div class="title-line"></div>
                            </div>
                            <div class="section-content">
                                <div class="info-item description-item">
                                    <label>问题描述：</label>
                                    <div class="description-text">{{ currentOrder?.description || '暂无描述' }}</div>
                                </div>
                            </div>

                            <div class="section-title">
                                <i class="el-icon-user-solid"></i>
                                团队类型
                                <div class="title-line"></div>
                            </div>
                            <div class="section-content">
                                <div class="info-item">
                                    <label>团队类型：</label>
                                    <span class="text-left">{{ currentOrder?.teamType || '-' }}</span>
                                </div>
                            </div>
                        </div>

                        <div class="section">
                            <div class="section-title">
                                <i class="el-icon-document-copy"></i>
                                对账凭证分类
                                <div class="title-line"></div>
                            </div>
                            <div class="section-content">
                                <div class="evidence-section">
                                    <div class="evidence-item">
                                        <h4>收款信息</h4>
                                        <div class="info-item">
                                            <label>收款金额：</label>
                                            <span>{{ receiptAmount }}</span>
                                        </div>
                                        <div class="info-item">
                                            <label>收款账户：</label>
                                            <span>{{ receiptAccount }}</span>
                                        </div>
                                        <div class="info-item">
                                            <label>交易订单号：</label>
                                            <span>{{ receiptOrderNo }}</span>
                                        </div>
                                    </div>
                                    <div class="evidence-item">
                                        <h4>付款信息</h4>
                                        <div class="info-item">
                                            <label>支付金额：</label>
                                            <span>{{ paymentAmount }}</span>
                                        </div>
                                        <div class="info-item">
                                            <label>支付账户：</label>
                                            <span>{{ paymentAccount }}</span>
                                        </div>
                                        <div class="info-item">
                                            <label>交易订单号：</label>
                                            <span>{{ paymentOrderNo }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="section">

                            <div class="section-title">
                                <i class="el-icon-s-order"></i>
                                工单状态
                                <div class="title-line"></div>
                            </div>
                            <div class="section-content">
                                <div class="info-item">
                                    <label>工单状态：</label>
                                    <span class="status-text">{{ currentOrder?.status }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="section">
                            <div class="section-title">
                                <i class="el-icon-finished"></i>
                                投诉处理结果
                                <div class="title-line"></div>
                            </div>
                            <div class="section-content">
                                <div class="info-item">
                                    <label>处理类型：</label>
                                    <span class="text-left">{{ currentOrder?.handleType }}</span>
                                </div>
                                <div class="info-item">
                                    <label>处理结果：</label>
                                    <span class="text-left">{{ currentOrder?.handleResult || '暂无处理结果' }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { getDictData } from '@/api/dict'
import request from '@/utils/request'
import moment from 'moment'

export default {
    name: 'WorkOrderList',
    data() {
        return {
            loading: false,
            tableData: [],
            userList: [],
            total: 0,
            currentPage: 1,
            searchForm: {
                page: 1,
                pagesize: 5,
                work_order_id: '',
                complaint_iccid: '',
                status_no: '',
                source_no: '',
                timeRange: [],
                start_time: '',
                end_time: '',
                process_type_no: '',
                complaint_no: ''
            },
            dialogVisible: false,
            currentOrder: null,
            sourceChannel: '客服热线',
            urgencyLevel: '紧急',
            issueTime: '2024-03-14 10:30:00',
            complaintItem: '物联网卡问题',
            iccid: '898600XXXXXXXXXX',
            cardNumber: '13800138000',
            phoneNumber: '13900139000',
            userIccid: '898600XXXXXXXXXX',
            channelCode: 'CH001',
            userType: '套餐用户',
            agentName: '某某科技有限公司',
            receiptAmount: '1000.00',
            receiptAccount: '6222XXXXXXXXXXXX',
            receiptOrderNo: 'RO2024031400001',
            paymentAmount: '1000.00',
            paymentAccount: '6222XXXXXXXXXXXX',
            paymentOrderNo: 'PO2024031400001',
            pickerOptions: {
                shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                        const end = new Date()
                        const start = new Date()
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
                        picker.$emit('pick', [start, end])
                    }
                }, {
                    text: '最近一个月',
                    onClick(picker) {
                        const end = new Date()
                        const start = new Date()
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
                        picker.$emit('pick', [start, end])
                    }
                }]
            },
            processResultList: [],
            handleTypeList: [],
            complaintOptions: [],
            sourceChannelList: [],
            statusList: [],
            userLoading: false,
            exportProgress: 0,  // 导出进度
        }
    },
    created() {
        // 设置默认时间范围为最近7天
        this.setDefaultTimeRange()
        this.loadConfig()
        this.getWorkOrderList()
    },
    mounted() {
       
    },
    methods: {
        // 设置默认时间范围为最近7天
        setDefaultTimeRange() {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7) // 7天前

            this.searchForm.timeRange = [
                moment(start).format('YYYY-MM-DD'),
                moment(end).format('YYYY-MM-DD')
            ]
            this.searchForm.start_time = moment(start).format('YYYY-MM-DD HH:mm:ss')
            this.searchForm.end_time = moment(end).format('YYYY-MM-DD HH:mm:ss')
        },

        //定义一个通用方法，根据类型获取字典数据
        async getDictData(_type) {
            const response = await getDictData(_type)
            if (response.status === 1) {
                return response.data
            }
        },

        //获取用户列表
        async getUserList(key) {
 

            let params = {}
            if (!key) {
                params = {
                    page: 1,
                    size: 10,
                    single_dept_id: "e1c8b45f-54dd-5811-9412-c93cd6068bdf"
                }
            } else {
                params = {
                    page: 1,
                    size: 10,
                    username: key
                }
            }

          

            const response = await request({
                url: '/api/v1/user/list',
                method: 'POST',
                data: params
            })

            if (response.status === 1 && response.data) {
                this.userList = response.data.list || []
            } else {
                this.$message.error(response.message || '获取数据失败')
            }
            
        },

        transformDictDataFirstLevel(data) {
            return data.filter(item => item.parentId === '0')
        },

        // 转换字典数据为级联选择器格式
        transformDictData(data) {
            // 创建一个 Map 来存储所有节点
            const childrenMap = new Map();

            // 第一次遍历，初始化所有节点
            data.forEach(item => {
                const node = {
                    value: item.itemValue,
                    label: item.itemLabel,
                    children: []
                };
                // 使用 itemId 作为 key，因为 parentId 是引用 itemId
                childrenMap.set(item.itemId, node);
            });

            // 第二次遍历，建立父子关系
            data.forEach(item => {
                // 如果 parentId 不为 0，则建立父子关系
                if (item.parentId && item.parentId !== '0') {
                    const parentNode = childrenMap.get(item.parentId);
                    if (parentNode) {
                        parentNode.children.push(childrenMap.get(item.itemId));
                    }
                }
            });

            // 返回顶级节点（parentId 为 0 的节点）
            return data
                .filter(item => !item.parentId || item.parentId === '0')
                .map(item => childrenMap.get(item.itemId));
        },
        //加载配置数据
        async loadConfig() {
            this.sourceChannelList = await this.getDictData("KFTSLY")
            this.handleTypeList = await this.getDictData("KFTSLX")
            this.handleTypeList = this.transformDictData(this.handleTypeList)
            this.processResultList = await this.getDictData("KFTSJG")
            this.processResultList = this.transformDictData(this.processResultList)
            this.statusList = await this.getDictData("KFGDZT")
            this.complaintOptions = await this.getDictData('KFTSXM') // 投诉项目
            this.complaintOptions = this.transformDictData(this.complaintOptions) // 转换为级联格式
        },

        handleSearch() {
            this.searchForm.page = 1  // 搜索时重置为第1页
            // 处理时间范围
            if (this.searchForm.timeRange && this.searchForm.timeRange.length === 2) {
                this.searchForm.start_time = moment(this.searchForm.timeRange[0]).format('YYYY-MM-DD HH:mm:ss')
                this.searchForm.end_time = moment(this.searchForm.timeRange[1]).format('YYYY-MM-DD HH:mm:ss')
            }
            this.getWorkOrderList()
        },
        resetSearch() {
            this.searchForm = {
                page: 1,
                pagesize: 5,
                work_order_id: '',
                complaint_iccid: '',
                status_no: '',
                source_no: '',
                timeRange: [],
                start_time: '',
                end_time: '',
                process_type_no: '',
                complaint_no: '',
                loginUser: ''
            }
            // 重置后也设置默认时间为最近7天
            this.setDefaultTimeRange()
            this.getWorkOrderList()
        },
        handleSizeChange(val) {
            this.searchForm.pagesize = val
            this.searchForm.page = 1  // 切换每页条数时重置为第1页
            this.getWorkOrderList()
        },
        handleCurrentChange(val) {
            this.searchForm.page = val
            this.getWorkOrderList()
        },
        async getWorkOrderList() {
            this.loading = true
            console.log('发送的搜索参数:', this.searchForm)
            try {
                const response = await request({
                    url: '/api/v1/kf-work-order/manage-page',
                    method: 'POST',
                    data: this.searchForm
                })
                 console.log('后端返回的数据:', response.data) 
               

                if (response.status === 1 && response.data) {
                    this.tableData = response.data.list || []
                    this.total = response.data.total || 0
               
                } else {
                    this.$message.error(response.message || '获取数据失败')
                }
            } catch (error) {
                console.error('获取工单列表失败:', error)
                this.$message.error('获取数据失败')
            } finally {
                this.loading = false
            }
        },
        formatRegDateTime(time) {
            if (!time) return '--'
            return time.replace('T', ' ').split('+')[0]
        },
        isOverdue(createTime) {
            const now = new Date()
            const createDate = new Date(createTime)
            const diffHours = (now - createDate) / (1000 * 60 * 60)

            return diffHours > 24
        },
        getRowClassName({ row, rowIndex }) {
            if (this.currentPage === 1 &&
                row.status !== '已完结' &&
                this.isOverdue(row.createTime)) {
                return 'overdue-row'
            }
            return ''
        },
        handleView(row) {
            this.currentOrder = row
            this.dialogVisible = true
        },
        handleEdit(row) {
            this.$router.push({
                path: '/service/complaint',
                query: {
                    id: row.work_order_id,
                    type: 'edit'
                }

            })
        },
        handleDelete(row) {
            this.$confirm('确认删除该工单?', '提示', {
                type: 'warning'
            }).then(() => {
                this.$message.success('删除成功')
            }).catch(() => { })
        },

        //计算工单流转时长
        calculateFlowTime(createTime) {
            const now = new Date()
            const createDate = new Date(createTime)
            const diffHours = (now - createDate) / (1000 * 60 * 60)
            //大于24小时，显示天数
            if (diffHours > 24) {
                return Math.floor(diffHours / 24) + '天'
            }
            return diffHours.toFixed(2)
        },

        // 根据complaint_no获取完整的投诉项目路径
        getComplaintFullPath(complaintNo) {
            if (!complaintNo) return '-'

            // 递归查找目标值在树中的完整路径
            const findPathInTree = (value, options, currentPath = []) => {
                for (const option of options) {
                    // 找到目标节点,返回完整路径
                    if (option.value === value) {
                        return [...currentPath, option.label]
                    }

                    // 如果有子节点,递归查找
                    if (option.children && option.children.length > 0) {
                        const result = findPathInTree(value, option.children, [...currentPath, option.label])
                        if (result) {
                            return result
                        }
                    }
                }
                return null
            }

            const pathArray = findPathInTree(complaintNo, this.complaintOptions)
            return pathArray ? pathArray.join('/') : '-'
        },

        // getUrgencyType(level) {
        //     const types = {
        //         '紧急': 'danger',
        //         '普通': 'warning',
        //         '低级': 'info'
        //     }
        //     return types[level] || 'info'
        // },
        // getStatusType(status) {
        //     const types = {
        //         '已登记': 'info',
        //         '处理中': 'warning',
        //         '已完结': 'success'
        //     }
        //     return types[status] || 'info'
        // },
        // (createTime) {
        //     if (!createTime) return '-';

        //     const now = new Date();
        //     const create = new Date(createTime);
        //     const diff = now - create;

        //     const hours = Math.floor(diff / (1000 * 60 * 60));

        //     if (hours >= 24) {
        //         return '24小时';
        //     } else {
        //         return `${hours}小时`;
        //     }
        // },
        getStatusType(status) {
            const types = {
                '待处理': 'warning',
                '处理中': 'primary',
                '已完成': 'success',
                '已关闭': 'info'
            }
            return types[status] || 'info'
        },
        // 导出数据
        async handleExport() {
            this.exportProgress = 0

            // 使用自定义的进度条对话框
            const h = this.$createElement
            const progressContent = h('div', {
                style: {
                    padding: '20px',
                    textAlign: 'center'
                }
            }, [
                h('p', {
                    style: {
                        fontSize: '16px',
                        color: '#606266',
                        marginBottom: '20px'
                    },
                    attrs: { id: 'export-status-text' }
                }, '正在准备导出数据...'),
                h('el-progress', {
                    props: {
                        percentage: this.exportProgress,
                        color: '#67C23A',
                        'stroke-width': 20,
                        'text-inside': true
                    },
                    attrs: { id: 'export-progress-bar' }
                })
            ])

            const msgBox = this.$msgbox({
                title: '导出进度',
                message: progressContent,
                showCancelButton: false,
                showConfirmButton: false,
                closeOnClickModal: false,
                closeOnPressEscape: false,
                customClass: 'export-progress-dialog'
            })

            // 模拟进度更新
            const updateProgress = (progress, text) => {
                this.exportProgress = progress
                const statusText = document.getElementById('export-status-text')
                const progressBar = document.getElementById('export-progress-bar')
                if (statusText) statusText.textContent = text
                if (progressBar) {
                    progressBar.__vue__.percentage = progress
                }
            }

            try {
                // 第一阶段：准备参数 (0-10%)
                updateProgress(10, '正在准备导出参数...')

                // 构建导出参数 - 使用和搜索相同的条件
                let params = {
                    complaint_iccid: this.searchForm.complaint_iccid || '',
                    loginUser: this.searchForm.loginUser || '',
                    source_no: this.searchForm.source_no || '',
                    process_type_no: this.searchForm.process_type_no || '',
                    complaint_no: this.searchForm.complaint_no || '',
                    status_no: this.searchForm.status_no || ''
                }

                // 处理时间范围
                if (this.searchForm.timeRange && this.searchForm.timeRange.length === 2) {
                    params.start_time = moment(this.searchForm.timeRange[0]).format('YYYY-MM-DD HH:mm:ss');
                    params.end_time = moment(this.searchForm.timeRange[1]).format('YYYY-MM-DD HH:mm:ss');
                }

                console.log('导出参数:', params)

                // 第二阶段：发送请求 (10-30%)
                updateProgress(30, '正在向服务器发送请求...')

                // 创建一个进度模拟器，在等待后端响应时更新进度
                const progressSimulator = setInterval(() => {
                    if (this.exportProgress < 80) {
                        updateProgress(this.exportProgress + 5, '正在生成 Excel 文件，请耐心等待...')
                    }
                }, 800)

                // 发送导出请求 - 使用全局600秒超时配置
                const response = await request({
                    url: '/api/v1/kf-work-order/export',
                    method: 'POST',
                    data: params
                })

                // 清除进度模拟器
                clearInterval(progressSimulator)

                // 第三阶段：文件生成成功 (80-90%)
                updateProgress(90, '文件生成成功，准备下载...')

                // 创建下载链接并自动点击下载
                const downloadUrl = "/api/api/v1/account_xlsx/" + response.data
                const link = document.createElement('a')
                link.href = downloadUrl
                link.download = response.data // 使用后端返回的文件名
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)

                // 第四阶段：完成 (100%)
                updateProgress(100, '导出完成！')

                // 延迟关闭对话框，让用户看到完成状态
                setTimeout(() => {
                    msgBox.close()

                    // 显示带下载链接的成功提示
                    const h = this.$createElement
                    this.$notify({
                        title: '导出成功',
                        message: h('div', null, [
                            h('p', { style: { marginBottom: '10px' } }, '文件已生成，如果没有自动下载，请点击下方链接：'),
                            h('a', {
                                attrs: {
                                    href: downloadUrl,
                                    download: response.data,
                                    target: '_blank'
                                },
                                style: {
                                    color: '#409EFF',
                                    textDecoration: 'underline',
                                    cursor: 'pointer',
                                    fontSize: '14px',
                                    fontWeight: '500'
                                }
                            }, '📥 点击这里下载文件')
                        ]),
                        type: 'success',
                        duration: 10000,
                        position: 'top-right'
                    })
                }, 1000)

            } catch (error) {
                // 关闭对话框
                msgBox.close()

                console.error('导出失败:', error)
                this.$message.error('导出失败，请重试')
            }
        },
        // 添加远程搜索方法
        async remoteSearch(query) {
            this.userList = []
            this.userLoading = true
            try {
                if (query) {
                    await this.getUserList(query)
                } else {
                    await this.getUserList() // 如果查询为空，加载默认部门
                }
            } catch (error) {
                console.error('搜索用户失败:', error)
                this.$message.error('搜索用户失败')
            } finally {
                this.userLoading = false
            }
        },
        // 添加单个字段清除方法
        handleClear(field) {
            // 清除指定字段
            this.searchForm[field] = field === 'timeRange' ? [] : ''

            // 如果是时间范围，同时清除开始和结束时间
            if (field === 'timeRange') {
                this.searchForm.start_time = ''
                this.searchForm.end_time = ''
            }

            // 重新搜索
            this.searchForm.page = 1
            this.getWorkOrderList()
        },
        // 添加处理focus事件的方法
        handleUserSelectFocus() {
            if (this.userList.length === 0) {
                this.getUserList() // 这里不传参数，会触发加载默认部门的逻辑
            }
        },
    }
}
</script>

<style scoped>
.work-order-list {
    padding: 20px;
    background-color: #f0f5ff;
}

.search-wrapper {
    background: #fff;
    padding: 20px;
    margin-bottom: 16px;
}

.search-form {
    background: #fff;
    border-radius: 8px;
    padding: 20px;
    margin-bottom: 20px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
}

.el-row {
    margin-bottom: 10px;
}

.form-item-wrapper {
    display: flex;
    align-items: center;
    height: 34px;
    position: relative;
    margin-bottom: 10px;
    padding: 0;
    width: 100%;
}

.label {
    color: #606266;
    font-size: 14px;
    white-space: nowrap;
    width: 75px !important;
    line-height: 32px;
    text-align: right;
    padding-right: 1px;
    margin-right: 1px;
    flex-shrink: 0;
    display: inline-block;
    justify-content: flex-end;
}

.el-input,
.el-select,
.el-date-editor,
.el-cascader {
    margin-left: 1px;
    width: calc(100% - 80px) !important;
}

:deep(.el-date-editor--daterange) {
    width: calc(100% - 80px) !important;
}



.el-input,
.el-select,
:deep(.el-date-editor) {
    margin-left: 1px;
}

/* 按钮行样式 */
.button-row {
    display: flex;
    justify-content: flex-end;
    height: 32px;
    line-height: 25px;
    padding-left: 20px;
}

/* 调整按钮之间的间距 */
.el-button+.el-button {
    margin-left: 10px;
}

/* 行间距 */
.el-row:last-child {
    margin-bottom: 0;
}

.table-section {
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
}

.table-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    border-bottom: 1px solid #e8f0ff;
    background: linear-gradient(to right, #f5f9ff, #fff);
    border-radius: 8px 8px 0 0;

    .header-left {
        display: flex;
        align-items: center;
        gap: 12px;

        h3 {
            font-size: 18px;
            color: #1a1a1a;
            position: relative;
            padding-left: 12px;
            margin: 0;
            display: flex;
            align-items: center;

            &:before {
                content: '';
                position: absolute;
                left: 0;
                top: 50%;
                transform: translateY(-50%);
                width: 4px;
                height: 16px;
                background: #409EFF;
                border-radius: 2px;
            }
        }

        .total-count {
            background: #f0f7ff;
            color: #409EFF;
            padding: 4px 12px;
            border-radius: 12px;
            font-size: 13px;
            margin-left: 12px;
            display: inline-flex;
            align-items: center;

            &:before {
                content: '';
                display: inline-block;
                width: 4px;
                height: 4px;
                background: #409EFF;
                border-radius: 50%;
                margin-right: 6px;
            }
        }
    }

    .header-right {
        .el-button {
            padding: 10px 20px;
            border-radius: 4px;
            font-weight: 500;
            transition: all 0.3s ease;

            i {
                margin-right: 6px;
            }

            &:hover {
                transform: translateY(-1px);
                box-shadow: 0 4px 12px rgba(64, 158, 255, 0.2);
            }
        }
    }
}

.audit-list {
    padding: 20px;
    background: #f8faff;
}

.audit-item {
    background: #fff;
    border-radius: 8px;
    margin-bottom: 16px;
    border: 1px solid #e8f0ff;
    transition: all 0.3s ease;

    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 8px 16px rgba(64, 158, 255, 0.1);
    }

    .info-container {
        .info-header {
            background: #f8faff;
            padding: 16px 20px;
            border-bottom: 1px solid #e8f0ff;
        }

        .info-content {
            padding: 20px;

            .info-item {
                background: #f8faff;
                padding: 12px 16px;
                border-radius: 6px;
                margin-bottom: 12px;
                transition: all 0.3s ease;

                &:hover {
                    background: #f0f7ff;
                }
            }
        }
    }
}

/* 分页样式优化 */
.pagination-container {
    padding: 20px;
    text-align: right;
    background: #fff;
    border-radius: 0 0 8px 8px;
}

.tech-dialog {
    border-radius: 8px;
    background: linear-gradient(to bottom, #ffffff, #f8faff);
    box-shadow: 0 12px 32px 4px rgba(0, 0, 0, .1);
}

.tech-dialog .el-dialog__header {
    background: linear-gradient(90deg, #f0f2f5, #e6e9f0);
    padding: 20px;
    border-bottom: 1px solid #ebeef5;
    border-radius: 8px 8px 0 0;
}

.tech-dialog .el-dialog__title {
    font-size: 18px;
    color: #2c3e50;
    font-weight: 600;
}

.order-number {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 24px;
    padding: 16px 20px;
    background: #fff;
    border-radius: 8px;
    border: 1px solid #ebeef5;
}

.order-number .number {
    font-size: 20px;
    font-weight: 600;
    color: #2c3e50;
    font-family: 'Monaco', monospace;
}

.detail-grid {
    padding: 0 20px;
}

.section {
    background: #fff;
    border-radius: 4px;
    border: 1px solid #ebeef5;
}

.section-title {
    padding: 12px 15px;
    border-bottom: 1px solid #ebeef5;
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 500;
    color: #303133;
    background-color: #fff;
}

.section-title i {
    margin-right: 8px;
    color: #409EFF;
}

.section-content {
    padding: 15px;
    background-color: #fff;
}

.info-item {
    display: flex;
    margin-bottom: 12px;
}

.info-item:last-child {
    margin-bottom: 0;
}

.info-item label {
    width: 100px;
    color: #909399;
    text-align: right;
    padding-right: 12px;
    flex-shrink: 0;
}

.info-item span {
    flex: 1;
    color: #2c3e50;
    text-align: left;
}

.text-left {
    text-align: left !important;
    word-break: break-all;
    white-space: normal;
    line-height: 1.5;
}

.el-tag {
    margin-left: 12px;
}

:deep(.el-tag) {
    border-radius: 4px;
    padding: 0 12px;
    height: 28px;
    line-height: 28px;
    font-weight: 500;
}

@keyframes fadeInUp {
    from {
        opacity: 0;
        transform: translateY(10px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@media (prefers-color-scheme: dark) {
    .section {
        background: #1e1e1e;
        border-color: #333;
    }

    .info-item label {
        color: #909399;
    }

    .info-item span {
        color: #e0e0e0;
    }
}

.description-text {
    display: inline-block;
    width: 100%;
    
    text-overflow: ellipsis;
    white-space: nowrap;
}

:deep(.el-table__row) {
    line-height: 1.5;
}

:deep(.el-tooltip__popper) {
    max-width: 400px;
    line-height: 1.5;
    padding: 10px;
}

:deep(.el-table) {

    th.el-table__cell,
    td.el-table__cell {
        text-align: center !important;
    }

    .cell {
        text-align: center;
        display: inline-block !important;
        width: 100% !important;
    }
}

.sub-text {
    text-align: center;
    font-size: 12px;
    color: #909399;
    margin-top: 4px;
    width: 100%;
    display: inline-block;
}

.description-text {
    display: inline-block;
    width: 100%;
   
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: left;
}

:deep(.el-table .cell) {
    display: flex;
    justify-content: center;
    align-items: center;
}

:deep(.el-table .cell .el-button--text) {
    margin: 0 5px;
}

.search-form .el-form-item {
    margin-bottom: 0;
    margin-right: 20px;
    text-align: left;
}

.table-header {
    text-align: center;
}

:deep(.el-tag) {
    display: inline-flex;
    justify-content: center;
    align-items: center;
}

:deep(.el-table .cell .el-button-group) {
    display: flex;
    justify-content: center;
    gap: 8px;
}

:deep(.el-tag) {
    display: inline-block;
}

:deep(.el-table__cell .cell .el-button) {
    padding: 0 8px;
}

:deep(.el-table__header-wrapper th) {
    font-weight: 500;
    color: #303133;
}

:deep(.el-table .cell .el-button-group) {
    text-align: center;
    width: 100%;
}

:deep(.el-table__row) {
    height: 50px;
}

.pagination-container {
    margin-top: 20px;
    padding-top: 20px;
    border-top: 1px solid #e8f0ff;
    text-align: right;
    display: flex;
    justify-content: flex-end;
}

:deep(.el-pagination) {
    white-space: nowrap;
    padding: 0;
    margin: 0;
    display: flex;
    align-items: center;
}

:deep(.el-pagination__total),
:deep(.el-pagination__sizes) {
    margin-right: 16px;
}

:deep(.el-pager li) {
    margin: 0 4px;
}

.overdue-row {
    background-color: #FFF3F3 !important;
}

.overdue-row:hover>td {
    background-color: #FFE7E7 !important;
}

.el-icon-warning {
    cursor: pointer;
}

.status-text {
    color: #2c3e50;
    font-size: 14px;
    line-height: 1.6;
}

.section {
    background: #fff;
    border-radius: 4px;
    border: 1px solid #ebeef5;
}

.section-content {
    padding: 15px;
    background-color: #fff;
}

.info-item {
    display: flex;
    margin-bottom: 12px;
    align-items: flex-start;
    background-color: #fff;
}

.status-text.processing {
    color: #409EFF;
}

.status-text.completed {
    color: #67C23A;
}

.status-text.pending {
    color: #E6A23C;
}

:deep(.el-table .cell) {
    white-space: nowrap;

    text-overflow: ellipsis;
}

.iccid-column {
    font-family: monospace;
}

.search-form {
    background-color: #fff;
    padding: 15px;
    margin-bottom: 15px;
    border-radius: 4px;
}

.el-form-item {
    margin-bottom: 15px;
}

.el-date-picker {
    width: 260px;
}

.el-select,
.el-cascader {
    width: 240px;
}

/* 调整日期选择器的宽度 */
:deep(.el-date-editor--daterange) {
    width: 100% !important;
}

/* 调整按钮组的位置 */
.operation-btns {
    display: flex;
    justify-content: flex-end;
    height: 100%;
    align-items: center;
}

.operation-btns .el-button {
    margin-left: 10px;
}

/* 专门针对处理类型标签的样式 */
.process-type-label {
    padding-right: 30px !important;
    /* 增加处理类型标签的右侧间距 */
}

.audit-list {
    margin: 20px 0;
}

.audit-item {
    margin-bottom: 16px;

    &:hover {
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
    }
}

.info-container {
    .info-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 16px;
        padding-bottom: 12px;
        border-bottom: 1px solid #ebeef5;

        .header-left {
            display: flex;
            align-items: center;
            gap: 12px;

            .order-time,
            .creator {
                background: #f5f7fa;
                padding: 6px 12px;
                border-radius: 4px;
                color: #606266;
                font-size: 13px;
                display: inline-flex;
                align-items: center;
                gap: 4px;

                i {
                    color: #409EFF;
                    font-size: 14px;
                }
            }

            .creator {
                i {
                    color: #67C23A;
                }
            }
        }
    }

    .info-content {
        .info-item {
            margin-bottom: 12px;

            .label {
                color: #909399;
                margin-right: 8px;
            }

            .value {
                color: #303133;
                font-weight: 500;
            }

            .sub-text {
                color: #909399;
                font-size: 12px;
                margin-left: 8px;
            }
        }
    }
}

.el-card {
    border-radius: 8px;

    &:hover {
        transition: all 0.3s;
    }
}

.el-tag {
    border-radius: 4px;
}

.empty-data {
    padding: 40px 0;
    text-align: center;
}

.info-item {
    .value {
        i {
            font-size: 16px;
            margin-right: 8px;

            /* 图标颜色定制 */
            &.el-icon-tickets {
                color: #409EFF;
            }

            &.el-icon-document {
                color: #67C23A;
            }

            &.el-icon-cpu {
                color: #E6A23C;
            }

            &.el-icon-time {
                color: #909399;
            }

            &.el-icon-office-building {
                color: #9C27B0;
            }

            &.el-icon-s-custom {
                color: #2196F3;
            }

            &.el-icon-money {
                color: #4CAF50;
            }

            &.el-icon-warning-outline {
                color: #FF9800;
            }

            &.el-icon-document-copy {
                color: #1976D2;
            }

            &.el-icon-wallet {
                color: #795548;
            }

            &.el-icon-position {
                color: #67C23A;
                /* 使用绿色表示渠道 */
            }
        }
    }
}

/* 问题描述区域特殊样式 */
.desc-item {
    background: #fff8f0 !important;
    border-left: 4px solid #FF9800;

    .value {
        i {
            color: #FF9800 !important;
        }
    }
}

.el-main {
    background-color: #6993e7;
}

/* 覆盖 el-cascader 的默认样式 */
:deep(.el-cascader) {
    width: calc(100% - 80px) !important;
}

/* 确保 cascader 的输入框也是相同宽度 */
:deep(.el-cascader .el-input) {
    width: 100% !important;
    margin-left: 0;
}

/* 移除重复的样式定义 */
.el-input,
.el-select,
:deep(.el-date-editor) {
    margin-left: 1px;
}

/* 添加下拉选择器的样式 */
:deep(.el-select) {
    width: calc(100% - 80px) !important;
}

:deep(.el-select-dropdown__item) {
    height: 34px;
    line-height: 34px;
    padding: 0 15px;
}

/* 添加清除按钮的样式 */
:deep(.el-input__inner) {
    padding-right: 30px;
}

:deep(.el-input__suffix) {
    right: 5px;
}

:deep(.el-select .el-input.is-focus .el-input__inner) {
    border-color: #409EFF;
}

/* 导出进度对话框样式 */
:deep(.export-progress-dialog) {
    min-width: 500px;
    border-radius: 8px;

    .el-message-box__header {
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        padding: 20px;
        border-radius: 8px 8px 0 0;

        .el-message-box__title {
            color: #fff;
            font-size: 18px;
            font-weight: 600;
        }

        .el-message-box__headerbtn {
            display: none; /* 隐藏关闭按钮 */
        }
    }

    .el-message-box__content {
        padding: 30px 20px;

        .el-message-box__message {
            margin: 0;
        }
    }

    /* 进度条样式 */
    .el-progress {
        .el-progress-bar__outer {
            background-color: #f0f2f5;
        }

        .el-progress-bar__inner {
            background: linear-gradient(90deg, #67C23A 0%, #85ce61 100%);
            transition: width 0.6s ease;
        }

        .el-progress__text {
            color: #fff !important;
            font-weight: 600;
            font-size: 14px !important;
        }
    }
}

/* 下载成功通知框样式 */
:deep(.el-notification) {
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);

    .el-notification__title {
        color: #303133;
        font-weight: 600;
    }

    .el-notification__content {
        p {
            color: #606266;
            line-height: 1.6;
        }

        a {
            display: inline-block;
            padding: 8px 16px;
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            color: #fff !important;
            border-radius: 6px;
            text-decoration: none !important;
            transition: all 0.3s ease;
            margin-top: 8px;

            &:hover {
                transform: translateY(-2px);
                box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
            }
        }
    }
}
</style>
